module.exports = __webpack_public_path__ + "img/f4_1.75760258.png";